import * as moment from "moment";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function NodeModifiedTime({
    parentNode,
    node,
}: {
    parentNode: IWorkflowNode;
    node: IWorkflowNode;
}) {
    if (!parentNode.viewchronological) {
        return null;
    }

    const styleClass = StyleClass(`nodeModifiedTimeText`, {
        marginLeft: "5px",
        opacity: 0.5,
    });

    const tooltipText = moment(node.lastmodifiedtime).format(
        "dddd, MMMM Do YYYY, h:mm:ss a"
    );

    return (
        <span className={styleClass} data-tip={tooltipText}>
            {moment(node.lastmodifiedtime).local().fromNow()}
        </span>
    );
}
